import type {ComponentProps} from 'react';

import React from 'react';

import 'overlayscrollbars/overlayscrollbars.css';
import {OverlayScrollbars, ClickScrollPlugin} from 'overlayscrollbars';
import {OverlayScrollbarsComponent} from 'overlayscrollbars-react';
import bowser from 'bowser';
import {withCssModule} from '@pb/kit-util-with-css-module';

import {getDefaultOptions} from './getDefaultOptions';
import styles from './scroll.component.module.styl';

import type {OverlayScrollbarsComponentProps, OverlayScrollbarsComponentRef} from 'overlayscrollbars-react';

// Note: If scrollbars.clickScroll set to true the ClickScrollPlugin is required.
OverlayScrollbars.plugin(ClickScrollPlugin);

const classNames = withCssModule(styles);

// TODO: Temporary Safari fix - remove when Safari fixes container-query units bug in animations
// Related to: https://bugs.webkit.org/show_bug.cgi?id=299952, https://github.com/WebKit/WebKit/pull/52296
const isSafari = bowser.safari;

type NativeProps = Omit<OverlayScrollbarsComponentProps, 'ref' | 'onScroll'>;

export interface ScrollProps extends NativeProps {
    /**
     * Dark mode theme for the scrollbars. If true, the dark mode theme will be applied.
     */
    darkMode?: boolean,

    /**
     * Ref on OverlayScrollbarsComponent.
     */
    _ref?: React.Ref<OverlayScrollbarsComponentRef>,

    /**
     * Scroll event callback.
     */
    onScroll?: ComponentProps<'div'>['onScroll'],
}

export function Scroll(props: ScrollProps) {
    const {
        darkMode,
        options,
        _ref,
        onScroll,
        events,
        className,
        ...otherProps
    } = props;

    return (
        <OverlayScrollbarsComponent
            {...otherProps}
            className={classNames(className, {'scroll-safari-fix': isSafari})}
            events={{
                ...events,
                scroll: (_, event) => {
                    onScroll?.(event as unknown as React.UIEvent<HTMLDivElement>);
                    if (typeof events === 'object' && typeof events?.scroll === 'function') {
                        events.scroll(_, event);
                    }
                },
            }}
            ref={_ref}
            options={getDefaultOptions({
                darkMode,
                ...options,
            })}
        />
    );
}

